import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { PersistenceService } from './persistence.service';
import { isPlatformServer } from '@angular/common';


@Injectable()
export class PersistenceLocalStorageService extends PersistenceService {
  constructor(@Inject(PLATFORM_ID) private platformId: any,) {
    super();
  }

  set(key: string, data: any) {
    try {

      if (!isPlatformServer(this.platformId)) {
        localStorage.setItem(key, JSON.stringify(data));
      }
     
    } catch (e) {
    }
  }

  get(key: string): any {
    try {
      if (!isPlatformServer(this.platformId)) {
        return JSON.parse(localStorage.getItem(key));
      }
  
    } catch (e) {
     
    }

    return null;
  }

  setString(key: string, data: string) {
    try {
      if (!isPlatformServer(this.platformId)) {
        localStorage.setItem(key, data);
      }
    } catch (e) {
    }
  }

  getString(key: string): string {
    try {
      if (!isPlatformServer(this.platformId)) {
        return localStorage.getItem(key);
      }
    } catch (e) {
     
    }

    return null;
  }
}
